package org.teddapp.project.db.repo

import app.cash.sqldelight.coroutines.asFlow
import app.cash.sqldelight.coroutines.mapToList
import com.tedd.db.ProjectStatus
import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.withContext
import org.teddapp.project.db.newId
import org.teddapp.project.db.nowMillis

class ProjectStatusRepository(private val db: TeddDatabase) {

    fun observeAll(): Flow<List<ProjectStatus>> =
        db.projectStatusQueries.selectAll().asFlow().mapToList(Dispatchers.Default)

    fun observeByProject(projectId: String): Flow<List<ProjectStatus>> =
        db.projectStatusQueries.selectByProject(projectId).asFlow().mapToList(Dispatchers.Default)

    suspend fun terminalForProject(projectId: String): ProjectStatus? = withContext(Dispatchers.Default) {
        db.projectStatusQueries.terminalForProject(projectId).executeAsOneOrNull()
    }

    suspend fun create(
        projectId: String,
        name: String,
        color: String,
        orderIndex: Long,
        isTerminal: Boolean = false,
        id: String = newId("st"),
    ): String = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.projectStatusQueries.insert(id, projectId, name, color, orderIndex, if (isTerminal) 1 else 0, now, now)
        id
    }

    suspend fun update(
        id: String,
        name: String,
        color: String,
        orderIndex: Long,
        isTerminal: Boolean,
    ) = withContext(Dispatchers.Default) {
        db.projectStatusQueries.update(name, color, orderIndex, if (isTerminal) 1 else 0, nowMillis(), id)
    }

    suspend fun softDelete(id: String) = withContext(Dispatchers.Default) {
        val now = nowMillis()
        db.projectStatusQueries.softDelete(now, now, id)
    }
}